import { render } from "./SleepMediaViewer.vue?vue&type=template&id=36a33b0e&scoped=true"
import script from "./SleepMediaViewer.vue?vue&type=script&lang=js"
export * from "./SleepMediaViewer.vue?vue&type=script&lang=js"

import "./SleepMediaViewer.vue?vue&type=style&index=0&id=36a33b0e&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-36a33b0e"]])

export default __exports__